import React, {Component} from 'react'
import {connect} from 'react-redux'
import {FJUserAction} from "../../../redux/action/FJRoot.action";
import FJProjectName from "../view/FJProjectName";
import FJUtil from "../../../util/FJUtil";

class FJProjectNameContainer extends Component {

  componentDidMount() {
    FJUtil.setDocumentTitle(this.props.projectName);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.projectName !== prevProps.projectName) {
      FJUtil.setDocumentTitle(this.props.projectName);
    }
  }

  render() {
    let {
      projectName,
      updateProjectName,
      editProjectNameInNetwork,
      updateProjectOldName
    } = this.props;

    return (
        <FJProjectName projectName={projectName}
                       updateProjectName={updateProjectName}
                       editProjectNameInNetwork={editProjectNameInNetwork}
                       updateProjectOldName={updateProjectOldName}
        />
    )
  }
}

const mapStateToProps = function (state) {
  return {
    projectName: state.user.projectName,
  }
};

const mapDispatchToProps = function (dispatch) {
  return {
    updateProjectName: function (value) {
      dispatch(FJUserAction.updateProjectNameAction(value))
    },
    editProjectNameInNetwork: function () {
      dispatch(FJUserAction.editProjectNameInNetworkAction())
    },
    updateProjectOldName: function (shouldUpdateExportName) {
      dispatch(FJUserAction.updateProjectOldNameAction(shouldUpdateExportName))
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FJProjectNameContainer);
